import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'
import { NigerianNewsPapers } from '../../components/nigeriannewspapers'
import { NigerianNewsPaperData } from '../../nigeriannewspapers'

const NigerianNewspapers = () => {

    const [newspapers, setNewspapers ] = useState()
    const [ loading, setLoading ] = useState()
    const [error, setError ] = useState()
    const [errorMessage, setErrorMessage] = useState()

    useEffect(() => {
        let mounted = true;
        const nigerianNewspapers = async () => {
          try {
            const response = await fetch(
                
                ("https://nigeriana-api-staging.herokuapp.com/api/v1/library/public/newspapers"),
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );
            const data = await response.json();
            setNewspapers(data?.data?.results);
            console.log(setNewspapers(data?.data?.results));
            setLoading(false);
          } catch (error) {
            setError(true);
            setErrorMessage(error?.message);
            setLoading(false);
          }
        };
        if (mounted) {
            nigerianNewspapers();
            
        }
        return () => {
          mounted = false;
        }; 
      }, []);



  return (
    <Container>
        <NavBar />
        <InnerContainer>
            <h2> Top Nigerian Newspapers</h2>
            <p>Below are links to top Nigerian newspapers </p>

            <NewsCard>

                {
                    newspapers?.map((newspaper) => {
                        console.log(newspaper);
                        return(
                            <NigerianNewsPapers key={newspaper?.id} news={newspaper}/>
                            // department={newspaper.department}
                            // desc={newspaper.desc}
                            // list1={newspaper.list1}
                            // link={newspaper.link}
                            // operation={newspaper} 
                        )
                    })
                }

            
            </NewsCard>

        </InnerContainer>
        <Footer />
    </Container>
  )
}

const Container =  styled.section`
    width: 100%;
    max-width: 1250%;
    margin: 0 auto;  // center the page

    

`
const InnerContainer = styled.div`
    width: 80%;
    max-width: 1250%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    
    & > h2{
        margin-top: 45px;
    }

    & > p{

    }
`
const NewsCard = styled.div`
    margin-top: 20px;
    margin-bottom: 20px;
`

export {NigerianNewspapers}